export default __webpack_public_path__ + "static/home_about-7512af83d4327e11a58e51fe6bf92363.png";